import React from 'react';
import useSlideShowContext from '@/components/admin/SlideShow/stores/useSlideShowContext';
import { GlossaryTerm } from '../../../types';

interface GlossaryCardProps {
  glossaryTerm: GlossaryTerm;
}

const GlossaryCard = ({ glossaryTerm }: GlossaryCardProps) => {
  const locale = useSlideShowContext(state => state.locale);

  const term = locale === 'en' ? glossaryTerm.term_en : glossaryTerm.term_es;
  const example = locale === 'en' ? glossaryTerm.example_sentence_en : glossaryTerm.example_sentence_es;

  return (
    <div className="tw-flex tw-flex-col tw-items-center tw-justify-center">
      <img
        alt={glossaryTerm.term_en}
        className="tw-rounded-xl"
        src={glossaryTerm.s3_url}
      />
      <div className="tw-pt-4">
        <strong>{term}</strong>
      </div>
      <hr className="tw-w-4/5" />
      <div>
        <strong>Example:</strong>
        <div>{example}</div>
      </div>
    </div>
  );
};

export default GlossaryCard;
